import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

const base_url = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class LocationHttpService {
  constructor(private httpClient: HttpClient) {}

  public fetchAll(): Observable<any> {
    return this.httpClient.get(`${base_url}api/locations`);
  }

  public fetchById(id): Observable<any> {
    return this.httpClient.get(`${base_url}inventory/locations/${id}`);
  }

  public add(data): Observable<any> {
    return this.httpClient.post(`${base_url}inventory/locations`, data);
  }

  public update(id, data): Observable<any> {
    return this.httpClient.patch(`${base_url}inventory/locations/${id}`, data);
  }
}
